export const STATUSES = [
  { key: "todo", label: "To Do", color: "#64748b" },
  { key: "in_progress", label: "In Progress", color: "#3B82F6" },
  { key: "blocked", label: "Blocked", color: "#EF4444" },
  { key: "done", label: "Done", color: "#10B981" },
];

export const PRIORITIES = [
  { key: "low", label: "Low", color: "#64748b" },
  { key: "medium", label: "Medium", color: "#3B82F6" },
  { key: "high", label: "High", color: "#F59E0B" },
  { key: "critical", label: "Critical", color: "#EF4444" },
];

export const PMBOK_GROUPS = [
  "Initiating",
  "Planning",
  "Executing",
  "Monitoring & Controlling",
  "Closing",
];

export const PHASE_COLORS = {
  Initiating: "#0044FF",
  Planning: "#7C3AED",
  Executing: "#0EA5E9",
  "Monitoring & Controlling": "#F59E0B",
  Closing: "#10B981",
};

export const KNOWLEDGE_AREAS = [
  "Integration", "Scope", "Schedule", "Cost", "Quality",
  "Resource", "Communications", "Risk", "Procurement", "Stakeholder",
];

export const DEP_TYPES = [
  { key: "FS", label: "Finish → Start", short: "FS" },
  { key: "SS", label: "Start → Start", short: "SS" },
  { key: "FF", label: "Finish → Finish", short: "FF" },
  { key: "SF", label: "Start → Finish", short: "SF" },
];

export const statusMeta = (k) => STATUSES.find((s) => s.key === k) || STATUSES[0];
export const priorityMeta = (k) => PRIORITIES.find((p) => p.key === k) || PRIORITIES[1];

// Explicit PM track status (separate from workflow status)
export const TRACK_STATUSES = [
  { key: "on_track", label: "On Track", color: "#10B981" },
  { key: "at_risk", label: "At Risk", color: "#F59E0B" },
  { key: "jeopardy", label: "Jeopardy", color: "#EF4444" },
];
export const trackMeta = (k) => TRACK_STATUSES.find((s) => s.key === k) || TRACK_STATUSES[0];

// Roadmap / map health coloring
export const HEALTH_COLORS = {
  green: "#10B981", yellow: "#F59E0B", red: "#EF4444", blue: "#2563EB", gray: "#9CA3AF",
};
export const HEALTH_BG = {
  green: "#ECFDF5", yellow: "#FFFBEB", red: "#FEF2F2", blue: "#EFF6FF", gray: "#F3F4F6",
};
export const HEALTH_LABELS = {
  blue: "Complete", green: "On track", yellow: "At risk", red: "Off track", gray: "No committed date",
};

// True-up cadence options (PM controlled)
export const TRUEUP_FREQUENCIES = [
  { key: "daily", label: "Daily" },
  { key: "weekly", label: "Weekly" },
  { key: "biweekly", label: "Bi-weekly" },
  { key: "monthly", label: "Monthly" },
  { key: "custom", label: "Custom" },
];

// PMI RACI standard
export const RACI_ROLES = [
  { key: "responsible", letter: "R", label: "Responsible", color: "#10B981",
    desc: "Performs the work to complete the task. The executor who ensures the deliverable is completed on time. Can be one or many." },
  { key: "accountable", letter: "A", label: "Accountable", color: "#2563EB",
    desc: "Has final authority and signs off on the work. Exactly one accountable person per task to avoid ambiguity." },
  { key: "consulted", letter: "C", label: "Consulted", color: "#F59E0B",
    desc: "Provides input, expertise, or advice before the task is completed — usually SMEs or key stakeholders. Two-way communication." },
  { key: "informed", letter: "I", label: "Informed", color: "#64748b",
    desc: "Kept updated on progress or decisions but not directly involved in the work. One-way communication." },
];

export const PHASE_PALETTE = [
  "#0044FF", "#7C3AED", "#0EA5E9", "#F59E0B", "#10B981",
  "#EF4444", "#EC4899", "#14B8A6", "#6366F1", "#F97316",
];

export function phaseColor(phase, index = 0) {
  return PHASE_COLORS[phase] || PHASE_PALETTE[index % PHASE_PALETTE.length];
}

// Ordered, de-duplicated list of phases for a project (project.phases first, then any extra task phases)
export function derivePhases(project, tasks = []) {
  const ordered = [...(project?.phases || [])];
  tasks.forEach((t) => {
    if (t.phase && !ordered.includes(t.phase)) ordered.push(t.phase);
  });
  return ordered.length ? ordered : PMBOK_GROUPS;
}

export function buildPhaseColors(phases, overrides = {}) {
  const map = {};
  phases.forEach((p, i) => (map[p] = overrides[p] || phaseColor(p, i)));
  return map;
}

export const TIMEZONES = [
  "UTC", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
  "America/Sao_Paulo", "Europe/London", "Europe/Berlin", "Europe/Paris", "Asia/Dubai",
  "Asia/Kolkata", "Asia/Singapore", "Asia/Tokyo", "Australia/Sydney",
];

export const DURATION_UNITS = [
  { key: "days", label: "Days" },
  { key: "hours", label: "Hours" },
  { key: "months", label: "Months" },
];

// Convert a working-day count into the project's chosen display unit.
export const formatDuration = (days, unit = "days") => {
  const d = Number(days) || 0;
  if (unit === "hours") { const h = d * 8; return `${h % 1 ? h.toFixed(1) : h} ${h === 1 ? "hr" : "hrs"}`; }
  if (unit === "months") { const m = d / 20; const r = Math.round(m * 10) / 10; return `${r} ${r === 1 ? "mo" : "mos"}`; }
  return `${d % 1 ? d.toFixed(1) : d} ${d === 1 ? "day" : "days"}`;
};

export const MS_SHAPES = { triangle: "▼", diamond: "◆", circle: "●", square: "■", star: "★" };
